module.exports = __webpack_public_path__ + "static/media/editFocusUP.0e47c2f4.png";